<mat-dialog-content>
@if (showContactDetails) {
<app-userinfo-contact></app-userinfo-contact>
} @else {
  <h2 class="admin-subheader">Häufig gestellte Fragen</h2>
  <mat-accordion>
    @for (faq of FAQS; track $index) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <p class="admin-text caps">
            {{faq.question}}
          </p>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p  class="admin-text">
        {{faq.answer}}
      </p>
    </mat-expansion-panel>
    }
  </mat-accordion>
}
</mat-dialog-content>

@if (showContactDetails) {
<mat-dialog-actions align="end" class="dialog-actions-center">
  <button mat-flat-button (click)="hideContact()">Zurück</button>
</mat-dialog-actions>
} @else {
<mat-dialog-actions align="end" class="dialog-actions-space-between">
  <button mat-flat-button (click)="openContact()" cdkFocusInitial class="caps">Kontaktiere uns</button>
  <button mat-flat-button (click)="navigateToPayment()" class="caps pay-button">Jetzt bestellen</button>
</mat-dialog-actions>
}